import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Button from 'shared/Button';

class Header extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      title,
      content,
      backButtonLabel,
      showBackButton,
      onBackButtonClick,
      className
    } = this.props;

    return (
      <div className={cx('condition-view-header', className)}>
        <div className="container">
          <Button
            className="condition-view-header__back-button"
            onClick={onBackButtonClick}
            style={{ visibility: showBackButton ? 'visible' : 'hidden' }}
          >
            <i className="icon icon--back"/>
            { backButtonLabel }
          </Button>

          <h2 className="condition-view-header__title">{ title} </h2>

          { content }
        </div>
      </div>
    );
  }
}

Header.defaultProps = {
  className: '',
  backButtonLabel: 'Go back',
  showBackButton: false,
  title: '',
};

Header.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  content: PropTypes.node,
  showBackButton: PropTypes.bool,
  backButtonLabel: PropTypes.string,
  onBackButtonClick: PropTypes.func.isRequired
};

export default Header;
